import { render, staticRenderFns } from "./quickqiuzhi.vue?vue&type=template&id=657d49c2&scoped=true"
import script from "./quickqiuzhi.vue?vue&type=script&lang=js"
export * from "./quickqiuzhi.vue?vue&type=script&lang=js"
import style0 from "./quickqiuzhi.vue?vue&type=style&index=0&id=657d49c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657d49c2",
  null
  
)

export default component.exports